/* ============================================
   THEME.JS — Birdie Shots Core JS
   ============================================ */

'use strict';

// ---- Global Toast Notification ----
window.showToast = function(message, type = 'success') {
  const existing = document.querySelector('.toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = `toast toast--${type}`;
  toast.textContent = message;
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => toast.classList.add('is-visible'));
  });

  setTimeout(() => {
    toast.classList.remove('is-visible');
    setTimeout(() => toast.remove(), 400);
  }, 3500);
};

// ---- Hamburger / Nav Drawer ----
(function() {
  const hamburger = document.getElementById('hamburger-btn');
  const drawer = document.getElementById('nav-drawer');
  const overlay = document.getElementById('nav-overlay');
  const closeBtn = document.getElementById('nav-drawer-close');
  let isOpen = false;

  function openDrawer() {
    isOpen = true;
    hamburger?.classList.add('is-active');
    hamburger?.setAttribute('aria-expanded', 'true');
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-visible');
    overlay?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn?.focus();
  }

  function closeDrawer() {
    isOpen = false;
    hamburger?.classList.remove('is-active');
    hamburger?.setAttribute('aria-expanded', 'false');
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-visible');
    overlay?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    hamburger?.focus();
  }

  hamburger?.addEventListener('click', () => isOpen ? closeDrawer() : openDrawer());
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  // Trap focus in drawer
  drawer?.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') return;
    const focusable = this.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();

// ---- Sticky Header Hide on Scroll ----
(function() {
  const header = document.getElementById('site-header');
  if (!header) return;

  let lastScroll = 0;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const current = window.pageYOffset;
        if (current > 80) {
          header.classList.toggle('is-hidden', current > lastScroll);
        } else {
          header.classList.remove('is-hidden');
        }
        lastScroll = current;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

// ---- Scroll Animations ----
(function() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function observe() {
    const elements = document.querySelectorAll(
      '.animate-on-scroll, .animate-on-scroll--left, .animate-on-scroll--right, .stagger-children'
    );

    if (reducedMotion) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    elements.forEach(el => observer.observe(el));
  }

  observe();
  window.birdieAnimations = { observe };
})();

// ---- FAQ Accordion ----
document.querySelectorAll('.faq-item__trigger').forEach(trigger => {
  trigger.addEventListener('click', function() {
    const item = this.closest('.faq-item');
    const isOpen = item.classList.contains('is-open');

    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('is-open'));
    if (!isOpen) item.classList.add('is-open');
  });
});

// ---- Q&A Accordion ----
document.querySelectorAll('.qa-item__question').forEach(trigger => {
  trigger.addEventListener('click', function() {
    const item = this.closest('.qa-item');
    item.classList.toggle('is-open');
    const expanded = item.classList.contains('is-open');
    this.setAttribute('aria-expanded', expanded);
  });
});

// Gift message toggle and save are handled by delegated listeners in cart-drawer.js

// window.updateCartCount is defined in cart.js via window.Cart.refresh()

// ---- Page load animation ----
document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('main')?.classList.add('page-enter');
});
